import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import Games from '@/views/Games.vue'
import Recruit from '@/views/static/Recruit.vue'
import Partner from '@/views/static/Partner.vue'
import Faq from '@/views/static/Faq.vue'
import Login from '@/views/auth/Login.vue'
import Register from '@/views/auth/Register.vue'
import Orders from '@/views/Orders.vue'
import Coupons from '@/views/Coupons.vue'
import { isLoggedIn, syncSession } from '@/utils/auth'
import i18n from '@/i18n'

Vue.use(Router)

const ROUTE_TITLE_KEYS = {
  home: 'nav.home',
  games: 'nav.games',
  orders: 'orders.title',
  coupons: 'coupons.title',
  recruit: 'nav.recruit',
  partner: 'nav.partner',
  faq: 'nav.faq',
  login: 'auth.loginTitle',
  register: 'auth.registerTitle'
}

function updateDocumentTitle(to) {
  const brand = i18n.t('app.brand')
  const key = ROUTE_TITLE_KEYS[to.name]
  const page = key ? i18n.t(key) : ''
  document.title = page ? `${page} - ${brand}` : brand
}

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home', name: 'home', component: Home },
    { path: '/games', name: 'games', component: Games },
    { path: '/orders', name: 'orders', component: Orders, meta: { requiresAuth: true } },
    { path: '/coupons', name: 'coupons', component: Coupons, meta: { requiresAuth: true } },
    { path: '/recruit', name: 'recruit', component: Recruit },
    { path: '/partner', name: 'partner', component: Partner },
    { path: '/faq', name: 'faq', component: Faq },
    { path: '/login', name: 'login', component: Login, meta: { hideNav: true } },
    { path: '/register', name: 'register', component: Register, meta: { hideNav: true } }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, _from, next) => {
  syncSession()
  if ((to.name === 'login' || to.name === 'register') && isLoggedIn()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to.meta && to.meta.requiresAuth && !isLoggedIn()) {
    next({ name: 'login', query: { redirect: to.fullPath }, replace: true })
    return
  }
  next()
})

router.afterEach((to) => {
  updateDocumentTitle(to)
})

export default router
